export default __webpack_public_path__ + "static/media/bp-22.588fe37f.jpg";